
import { metaDataMixin } from '~/mixins'

export default {
  mixins: [
    metaDataMixin,
  ],
  async asyncData ({ $api, $config, store, route, params: { slug }, error }) {
    const { data: { items: story } = {} } = await $api.stories.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomain,
    })

    if (!story || !story[0]) {
      error({
        statusCode: 404,
        message: '(404) Rubriek niet gevonden',
        context: `Couldn't find story: ${slug}.`,
        severity: 'warning',
      })
      return false
    }

    const {
      id: storyId,
      name: title,
    } = story[0]

    // Set breadcrumbs
    await store.dispatch('breadcrumbs/set', {
      path: route.path,
      items: [
        {
          to: '/',
          label: 'Ik mis je',
        },
        {
          label: title,
        },
      ],
    })

    return {
      seo: {
        title,
        description: `Op zoek naar alle artikelen van '${title}'? Bekijk het overzicht van Ik mis je hier.`,
      },
      storyId,
      title,
    }
  },
  data () {
    return {
      articles: [],
      hasMore: false,
      storyId: null,
      seo: {
        title: null,
        description: null,
      },
      social: {
        image: 'https://584lyuyf5181.b-cdn.net/548cf3ba-83d3-4d41-a0c8-80162d1b443d',
      },
    }
  },
  async fetch () {
    const {
      data: {
        items: articles = [],
        meta: {
          total = 0,
        } = {},
      } = {},
    } = await this.$api.articles.getAll({
      offset: this.articles.length,
      limit: 12,
      story: this.storyId,
      domain: this.$config.preprEnvironmentDomain,
    })

    this.articles.push(...articles)
    this.hasMore = total > this.articles.length
  },
}
